import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Helper } from '../shared/Helper';
import { LoginService } from '../service/login.service';

@Injectable({
  providedIn: 'root'
}
)
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private loginService: LoginService) {

  }

  canActivate(route, state) {
    try {
      if (!Helper.isTokenExpired()) {
        var papel = Helper.getPapelToken();
        this.loginService.Logado = true;
        if (papel == 'Marketing')
        {
          const rotaAtual = route && route.routeConfig ? route.routeConfig.path : '';
          const rotasPermitidasMarketing = ['marketing', 'regiao', 'distribuidor', 'gerenciamento-leeds', 'estado-cidade'];

          if (rotasPermitidasMarketing.indexOf(rotaAtual) === -1) {
            Helper.NavToDashboard(this.router);
          }
        }
        else if (papel != "Usuario") {
          if (route.routeConfig.path == "") {
            Helper.NavToDashboard(this.router);
          }
        }
        else if ((papel != "Gerente") || (papel != "Vendedor")) {
          if (route.routeConfig.path == "admin") {
            Helper.NavToDashboard(this.router);
          }
        }
        return true;
      }
      else {
        this.loginService.Logado = false;
      }
    }
    catch (ex) {
      localStorage.removeItem("jwt");
    }
    this.router.navigate(["login"]);
    return false;
  }

}
